import { Mesh, MeshStandardMaterial, Object3D, Texture } from 'three';

/** Call on an instance clone, never the shared loader scene. */
/**
 * Put a look texture on a material. Many generated avatars reuse their base
 * texture as the emissive map too; leaving that one in place makes the
 * original outfit glow straight through the new look, so it is swapped with
 * the base map.
 */
export function applyLookMap(material: MeshStandardMaterial, texture: Texture, originalMap: Texture | null) {
  if (material.emissiveMap && (material.emissiveMap === originalMap || material.emissiveMap.source === originalMap?.source)) {
    material.emissiveMap = texture;
  }
  material.map = texture;
  material.needsUpdate = true;
}

export function isolateLookMaterials(root: Object3D) {
  const targets: MeshStandardMaterial[] = [];
  const restore: Array<() => void> = [];
  root.traverse(node => {
    const mesh = node as Mesh;
    if (!mesh.isMesh) return;
    const original = mesh.material;
    const copies = (Array.isArray(original) ? original : [original]).map(material => {
      if (!('map' in material)) return material;
      const copy = material.clone() as MeshStandardMaterial;
      targets.push(copy);
      return copy;
    });
    const assigned = Array.isArray(original) ? copies : copies[0];
    mesh.material = assigned;
    restore.push(() => { if (mesh.material === assigned) mesh.material = original; });
  });
  return { targets, dispose() {
    restore.forEach(fn => fn());
    targets.forEach(material => material.dispose());
  } };
}
